import React from "react";
import { PagingDesktopStyled } from "./styles.web";
function LayoutPage({ vertical, maxStyle, buttonType, onClick }) {
    return (React.createElement(PagingDesktopStyled, { vertical: vertical, isMaxSize: Boolean(maxStyle), type: buttonType, onClick: onClick }, buttonType));
}
export default React.memo(LayoutPage);
